import { useState } from 'react'
import { TextField, Menu, MenuItem, Box, InputAdornment, IconButton } from '@mui/material'
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { useTheme } from '@emotion/react'

const ActionSelector = ({
  actions = [],
  label = 'Actions',
  placeholder = 'Select action',
  error = false,
  disabled = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const theme = useTheme()

  const handleClick = (event) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleStatusSelect = (action) => {
    if (action.disabled) {
      return
    }
    if (action.action) {
      action.action()
    }
    handleClose()
  }

  return (
    <Box sx={{ minWidth: '5rem', width: '10em' }}>
      <TextField
        onClick={handleClick}
        variant='outlined'
        size='medium'
        fullWidth
        label={label}
        value=''
        placeholder={placeholder}
        error={error}
        disabled={disabled}
        InputProps={{
          readOnly: true,
          style: {
            minWidth: '10em',
            width: '5em',
            cursor: disabled ? 'default' : 'pointer'
          },
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                edge='end'
                disabled={disabled}
                sx={{
                  color: disabled
                    ? theme.palette.text.disabled
                    : theme.palette.text.secondary
                }}
              >
                {open ? <ArrowDropUp /> : <ArrowDropDown />}
              </IconButton>
            </InputAdornment>
          )
        }}
        InputLabelProps={{
          shrink: true
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            cursor: disabled ? 'default' : 'pointer',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: disabled
                ? theme.palette.action.disabled
                : theme.palette.primary.main
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main
            }
          },
          '& .MuiInputBase-input': {
            cursor: disabled ? 'default' : 'pointer'
          }
        }}
      />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: anchorEl ? anchorEl.offsetWidth : '5em',
            maxWidth: 500,
            '& .MuiList-root': {
              padding: 0
            }
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        {actions.map((status, index) => (
          <MenuItem
            key={index}
            onClick={() => handleStatusSelect(status)}
            disabled={!!status.disabled}
            sx={{
              padding: '12px 16px',
              fontSize: '1rem',
              '&:hover': {
                backgroundColor: theme.palette.action.hover
              },
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              wordBreak: 'normal'
            }}
          >
            {status.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}

export default ActionSelector
